;( function( $, window, document, undefined )
{
    'use strict';

    var pluginName = 'Snoozy',
        defaults   = {
            target        : '',
            endpoint      : '',
            pages         : 1,
            pageParamName : '/page/',
            params        : {}
        };

    function Plugin( element, options )
    {
        this.element       = element;
        this.$element      = $( element );
        this.$lastItem     = this.getLastItem();
        this.$loader       = this.$lastItem.clone().addClass( 'snoozy-loader' ).html( $( '#common-hidden-inline-loader' ).html() );
        this.$window       = $( window );
        this._defaults     = defaults;
        this._name         = pluginName;
        this.options       = $.extend( {}, defaults, options );
        this.didScroll     = false;
        this.interval      = null;
        this.intervalPause = 250;
        this.loading       = false;
        this.page          = 1;

        this.init();
    }

    Plugin.prototype = {

        init : function()
        {
            this.$window.on( 'scroll', $.proxy( this.onScroll, this ) );
            this.interval = setInterval( $.proxy( this.onScrollInterval, this ), this.intervalPause );
        },

        getLastItem : function()
        {
           return this.$element.children().last()
        },

        onScroll : function()
        {
            this.didScroll = true;
        },

        isLastElementInViewport : function()
        {
            var rect = this.$lastItem[ 0 ].getBoundingClientRect();

            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= this.$window.height() &&
                rect.right <= this.$window.width()
            );
        },

        loaded : function( data )
        {
            this.$loader.detach();
            this.loading = false;

            if( data )
            {
                this.$element.append( $( data ).find( this.options.target ).html() );

                this.$lastItem = this.getLastItem();
            }
        },

        more : function()
        {
            if( this.isLastElementInViewport() && !this.loading )
            {
                this.loading = true;
                this.page++;
                this.$loader.appendTo( this.$element );

                $.ajax( {
                    type  : 'GET',
                    url   : this.options.endpoint + this.options.pageParamName + this.page,
                    data  : this.options.params
                } ).done( $.proxy( this.loaded, this ) ).fail( $.proxy( this.loaded, this ) );
            }
        },

        onScrollInterval : function()
        {
            if( this.didScroll )
            {
                this.didScroll = false;

                if( this.page >= this.options.pages )
                {
                    clearInterval( this.interval );
                    this.$window.off( 'scroll', $.proxy( this.onScroll, this ) );
                }
                else
                {
                    this.more();
                }
            }
        }
    };

    $.fn[ pluginName ] = function( option )
    {
        var args = arguments
          , result;

        this.each( function()
        {
            var $this   = $( this )
              , data    = $.data( this, 'plugin_' + pluginName )
              , options = typeof option === 'object' && option;

            if( !data )
            {
                $this.data( 'plugin_' + pluginName, ( data = new Plugin( this, options ) ) );
            }

            if( typeof option === 'string' )
            {
                result = data[ option ].apply( data, Array.prototype.slice.call( args, 1 ) );
            }
        } );

        return result || this;
    };

} )( jQuery, window, document );